module.exports = __webpack_public_path__ + "media/male_resultF.c5f4a9f2.mp3";